import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import PublicPageLayout from '../PublicPageLayout';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import { customSizes } from '../../../assets/styles/themes/tokens';
import useRouter from '../../../utils/useRouter';
import { routes } from '../../../constants';
import MuLogo from '../SideNavbar/MuLogo';

interface PublicVideoPlayerLayoutProps {
  children: ReactNode;
  videoTitle?: string;
}

/**
 * Standalone layout for public video player page.
 * Provides a minimal top bar with logo and video title.
 */
const PublicVideoPlayerLayout: React.FC<PublicVideoPlayerLayoutProps> = ({
  children,
  videoTitle,
}) => {
  const { router } = useRouter();

  const handleLogoClick = () => {
    router.push(`/${routes.login.root}`);
  };

  return (
    <PublicPageLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {/* Top Bar */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: customSizes.sideNavbar.headerHeight.desktop,
            borderBottom: `1px solid ${palette.elevation.outlined}`,
            backgroundColor: palette.background.paperElevation2,
            paddingX: spaces.md,
            flexShrink: 0,
          }}
          data-testid='public-video-player-top-bar'
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <MuLogo variant='small' onClick={handleLogoClick} />
          </Box>
          {videoTitle && (
            <Typography
              variant='h6'
              sx={{
                flex: 1,
                marginLeft: spaces.lg,
                color: palette.text.primary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {videoTitle}
            </Typography>
          )}
        </Box>

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </Box>
      </Box>
    </PublicPageLayout>
  );
};

export default PublicVideoPlayerLayout;

